import environment from '#/environment/environment';
import {ExchangeRates} from '@shareland/shareland-common';

const fetchExchangeRates = async (): Promise<ExchangeRates | undefined> => {
  const response = await fetch(`${environment.apiUrl}/exchange_rates`);

  const json = await response.json();
  return json.data;
};

export default fetchExchangeRates;
